import { APP_PATHS, FLOW_STEP_PATHS } from '@/constants';

export const globalPrerequisites = ({ isUnmanagedKyc } = {}) => [
  !isUnmanagedKyc
    ? {
        prerequisite: 'hasStoreDetails',
        back: FLOW_STEP_PATHS.STORE_DETAILS_PATH,
      }
    : {
        prerequisite: 'hasSelectedProduct',
        back: FLOW_STEP_PATHS.PRODUCT_SELECTION_PATH,
      },
];

export const getNextAfterStepOne = ({ isManagedFlow } = {}) =>
  isManagedFlow ? FLOW_STEP_PATHS.DOCUMENTS : FLOW_STEP_PATHS.BANK_ACCOUNT_PATH;

export const prerequisitesForStoreDetails = ({ isUnmanagedKyc }) =>
  !isUnmanagedKyc ? {} : { prerequisite: 'hasSelectedProduct' };

export const getNextApplicationConfirmation = ({ isUnmanagedKyc }) =>
  !isUnmanagedKyc ? APP_PATHS.APPLICATION_OVERVIEW_PATH : FLOW_STEP_PATHS.APPLICATION_CHECKING_PATH;

export const getAfterFlowStep = ({ isUnmanagedKyc, isWidget }) =>
  isUnmanagedKyc
    ? isWidget
      ? FLOW_STEP_PATHS.APPLICATION_REVIEW
      : APP_PATHS.WHATS_NEXT_PATH
    : APP_PATHS.APPLICATION_OVERVIEW_PATH;
